import { render } from "./TestSn.vue?vue&type=template&id=076c5730&scoped=true"
import script from "./TestSn.vue?vue&type=script&lang=js"
export * from "./TestSn.vue?vue&type=script&lang=js"

import "./TestSn.vue?vue&type=style&index=0&id=076c5730&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076c5730"]])

export default __exports__